var styleDataHash = "3bc4715c";
const injectCss = () => {
  var css = `@charset "UTF-8";.BNGPI,.ReactModalPortal,.glob_fontElementMap,.njdjB,button{font-family:var(--ricos-font-family,unset)}._9cxbh{display:flex}[dir] .AR6TM:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .AR6TM:hover,[dir] .n9Mm0{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}[dir] .n9Mm0{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .rMHHV .n9Mm0{box-shadow:none!important}.mTaxD{display:block;height:100%;position:absolute;top:0;width:100%}[dir] .mTaxD{cursor:move}[dir=ltr] .mTaxD{left:0}[dir=rtl] .mTaxD{right:0}.mTaxD.GVymA{pointer-events:none}[dir] .PkEq0 ::selection{background:transparent}.j8df-{display:none}.njdjB{position:relative}._6ACSC{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{font-weight:300}[dir=ltr] .ReactModal__Content{direction:ltr}[dir=rtl] .ReactModal__Content{direction:rtl}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}._0doTD{color:#333;text-decoration:none}.fySmG{display:block}.g9zM2{position:relative}.x509C{overflow-x:auto;overflow-y:hidden}[dir=ltr] .x509C,[dir=rtl] .x509C{margin-left:-20px;margin-right:-20px}[dir] .x509C.V8Ece::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}[dir] .x509C._5a9Zp::-webkit-scrollbar-thumb{background-color:transparent}.Wk2LF{max-width:max-content!important;min-width:100%}.x509C::-webkit-scrollbar{-webkit-appearance:none}[dir] .x509C::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.x509C::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_default = {
  "fontElementMap": "BNGPI",
  "pluginContainer": "njdjB",
  "flex": "_9cxbh",
  "isFocusable": "AR6TM",
  "hasFocus": "n9Mm0",
  "dragImageView": "rMHHV",
  "overlay": "mTaxD",
  "noPointerEventsOnFocus": "GVymA",
  "hideTextSelection": "PkEq0",
  "hidden": "j8df-",
  "pluginContainerMobile": "_6ACSC",
  "isImage": "_0doTD",
  "anchor": "fySmG",
  "horizontalScrollbarWrapper": "g9zM2",
  "pluginWithHorizontalScrollbar": "x509C",
  "show": "V8Ece",
  "hide": "_5a9Zp",
  "horizontalScrollbar": "Wk2LF"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
